import script from "./ArtView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArtView.vue?vue&type=script&setup=true&lang=ts"

import "./ArtView.vue?vue&type=style&index=0&id=1cda2f12&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cda2f12"]])

export default __exports__